class QuickAtcUpsell extends HTMLElement {
  constructor(){
    super();
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
  }
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    // const variantCustomTab = this.querySelector('.variant-custom-tab');
    const pageShade = document.querySelector('.page-shade');
    const bodyElement = document.querySelector('body');
    const vpMobileToggle = this.querySelector('.vp-mobile-toggle');

    pageShade.addEventListener('click', () => {
        bodyElement.classList.remove('show-variant-picker');
        this.removeAttribute('open');
        this.ariaHidden = true;
    });

    vpMobileToggle.addEventListener('click', () => {
        bodyElement.classList.remove('show-variant-picker');
        this.removeAttribute('open');
        this.ariaHidden = true;
    });
    
    this.querySelectorAll(".opt-label-mobile").forEach( (element) => {
        element.addEventListener("click", () => {
            const bodyElement = document.querySelector('body');
            bodyElement.classList.remove('show-variant-picker');
            this.removeAttribute('open');
            this.ariaHidden = true;
            const forms = this.querySelectorAll('.js-product-form');

            const variantId = element.querySelector("span.opt-value").dataset.variantId;
            forms.forEach((form) => {
              const input = form.querySelector('[name="id"]');
              input.value = variantId ?? "";
              //input.dispatchEvent(new Event('change', { bubbles: true }));
            });
            setTimeout(() => {
              const addToCartForm = this.querySelector('form[action$="/cart/add"]');
              const formData = new FormData(addToCartForm);

              fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                body: formData
              })
              .then(response => {
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                  bubbles: true,
                }));
                return response.json();
              })
              .catch((error) => {
                console.error('Error:', error);
              });
            }, 50);
            
        });
    });
  }
}
window.customElements.define('quick-atc-upsell', QuickAtcUpsell);

/* global SideDrawer */

class QuickATCOpen extends HTMLElement {
  constructor(){
    super();
    this.productId = this.dataset.productId;
  }
  connectedCallback() {
    const atcUpsell = document.querySelector(`#atc-${this.productId}`);
    this.addEventListener('click', (event) => {
      event.preventDefault();
      if (atcUpsell) {
        const bodyElement = document.querySelector('body');
        bodyElement.classList.add('show-variant-picker');
        atcUpsell.setAttribute('open', '');
        atcUpsell.ariaHidden = false;
      }
    });
  }
}
window.customElements.define('quick-atc-open', QuickATCOpen);